import React, { useState } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import UserInfoForm, { UserInfo } from "../../components/UserInfoForm";
import ContentMarketingQuizContainer from "./ContentMarketingQuizContainer";
import ContentMarketingResults from "./ContentMarketingResults";

const ContentMarketingQuiz: React.FC = () => {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useState<UserInfo | null>(null);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <UserInfoForm
            subtitle="Create Content That Converts"
            onSubmit={(userData: UserInfo) => {
              setUserInfo(userData);
              navigate("quiz");
            }}
          />
        }
      />
      <Route
        path="quiz"
        element={<ContentMarketingQuizContainer userInfo={userInfo} />}
      />
      <Route path="results" element={<ContentMarketingResults />} />
    </Routes>
  );
};

export default ContentMarketingQuiz;
